import { render, staticRenderFns } from "./video_player.vue?vue&type=template&id=70c20b84&scoped=true&"
import script from "./video_player.vue?vue&type=script&lang=js&"
export * from "./video_player.vue?vue&type=script&lang=js&"
import style0 from "./video_player.vue?vue&type=style&index=0&id=70c20b84&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c20b84",
  null
  
)

export default component.exports